import $ from './XDomainJquery';
import {Modal, message} from 'antd';
import StringUtil from './StringUtil';
import ENV from './env.js';
import Fetch from './Fetch.js';
import API_URL from './url.js';

const obj = {};
if (ENV.CAS) {
    obj[header] = token;
}

export const xToken = obj;

export default class AjaxRequest {

    static sendRequest(options) {
        const datas = {};
        if (sessionStorage.curEnterpriseId && sessionStorage.curEnterpriseId > 0){
            datas.curEnterpriseId = sessionStorage.curEnterpriseId;
        }
        if (sessionStorage.userId && sessionStorage.userId > 0){
            datas.curUserId = sessionStorage.userId;
        }
        if (sessionStorage.invId && sessionStorage.invId > 0){
            datas.curInvId = sessionStorage.invId;
        }
        if (sessionStorage.siteId && sessionStorage.siteId > 0){
            datas.curSiteId = sessionStorage.siteId;
        }
        if (!StringUtil.isNull(sessionStorage.curRole)){
            datas.curRoleCode = sessionStorage.curRole;
        }
        if (!StringUtil.isNull(sessionStorage.positionRole)){
            datas.curPositionRoleCode = sessionStorage.positionRole;
        }
        if (!StringUtil.isNull(sessionStorage.curEmployeeCode)){
            datas.curEmployeeCode = sessionStorage.curEmployeeCode;
        }
        if (!StringUtil.isNull(sessionStorage.blindType)){
            datas.blindType = sessionStorage.blindType;
        }
        if (!StringUtil.isNull(sessionStorage.relatedSiteId)){
            datas.relatedSiteId = sessionStorage.relatedSiteId;
        }
        let method = options.method ? options.method : 'POST';
        if (window.XDomainRequest) {
            method = "get";
        }

        const showConfirm = (message, url) => {
            Modal.warning({
                title: message,
                content: '请重新登录',
                onOk() {
                    sessionStorage.clear();
                    location.href = url;
                },
            });
        }
        
        const encodedUrl = encodeURI(options.url).replace(/#/g, '%23');
        const tokenName = localStorage.tokenName;
        const tokenValue = localStorage.tokenValue;
        const loginType = localStorage.loginType || 'ADFS';
        
        
        const requestOptions = {
            method,
            url: encodedUrl,
            xhrFields: {
                withCredentials:true  //支持附带详细信息
            },
            headers: {
                [tokenName]: tokenValue,
                loginType: loginType,
            },
            data: {
                ...options.data,
                ...datas,
            },
            type: options.type,
            async: options.async == null || options.async == undefined ? true : options.async,
        };
        if (options.xhrFields) {
            requestOptions.xhrFields = {
                ...requestOptions.xhrFields,
                ...options.xhrFields,
            };
        }
        if (ENV.CAS) {
            requestOptions.beforeSend = function(xhr){
                xhr.setRequestHeader(header, token);
            }
        }

        $.ajax({
            ...requestOptions,
        }).done((result, status, xhr) => {
            if (result.error) {
                if(result.error == "NOACCESS"){
                    showConfirm();
                    return;
                }
                if(options.showError === 1 || options.showError === true || options.showError === undefined){
                    message.error(result.error);
                    // Modal.error({title: result.error});
                }
                if (options.errorResult){
                    options.errorResult(result.error);
                }
            } else if (result.errorCode == 402) {
                if(localStorage.is401 == 0){
                    showConfirm(result.message, result.redirectUrl);
                    localStorage.is401 = 1;
                }
                return;
            } else if (result.data && result.data.error) {
                if(options.showError === 1 || options.showError === true || options.showError === undefined){
                    message.error(result.data.error);
                    // Modal.error({title: result.data.error});
                }
                if (options.errorResult) {
                    options.errorResult(result.data.error);
                }
            } else {
                options.doneResult(result, status, xhr);
            }
        }).fail(result => {
            if (!options.hideFailMessage) {
                message.warning('获取服务失败，请刷新页面后重试');
            }
            if(options.failResult){
                options.failResult(result);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/common/AjaxRequest.js